export enum Breakpoints {
  MOBILE = 320,
  TABLET = 760,
  DESKTOP = 1024,
  DESKTOP_LG = 1152,
}

export const mq = (breakpoints: Breakpoints): string => `@media (min-width: ${breakpoints}px)`;
